import { render, staticRenderFns } from "./VehiclePropertyCostHistoryEditor.vue?vue&type=template&id=4daa69c4&scoped=true&"
import script from "./VehiclePropertyCostHistoryEditor.vue?vue&type=script&lang=js&"
export * from "./VehiclePropertyCostHistoryEditor.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePropertyCostHistoryEditor.vue?vue&type=style&index=0&id=4daa69c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa69c4",
  null
  
)

export default component.exports
import {QItem,QInput,QToolbar,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QToolbar,QSpace,QBtn}, component.options.components || {})
